import { useQuery } from 'react-query';
import request from '../../../helpers/request';
import queries from './queries';

const getMeterTypes = async () => {
  const data = await request.get(
    '/RentPlace/meter/type',
    {},
    'При загрузке типов счетчиков произошла ошибка',
    []
  );
  return data.sort((a, b) => a.orderNum - b.orderNum);
};

const useMeterTypes = () =>
  useQuery(queries.meterTypes, () => getMeterTypes(), {
    placeholderData: [],
  });

export default useMeterTypes;
